/**
 * @generated SignedSource<<925b377fa168a2327259c759f201d1c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SettingsApiKeyMutation$variables = {
  token: string;
  id: string;
};
export type SettingsApiKeyMutation$data = {
  readonly businessCreateApiKey: {
    readonly node: {
      readonly apiKeyId: string | null;
    } | null;
  };
};
export type SettingsApiKeyMutation = {
  variables: SettingsApiKeyMutation$variables;
  response: SettingsApiKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apiKeyId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsApiKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BusinessCreateApiKeyPayload",
        "kind": "LinkedField",
        "name": "businessCreateApiKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessAccount",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SettingsApiKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BusinessCreateApiKeyPayload",
        "kind": "LinkedField",
        "name": "businessCreateApiKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessAccount",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5afaeb0615eedce511bb6896785300f9",
    "id": null,
    "metadata": {},
    "name": "SettingsApiKeyMutation",
    "operationKind": "mutation",
    "text": "mutation SettingsApiKeyMutation(\n  $token: String!\n  $id: ID!\n) {\n  businessCreateApiKey(input: {token: $token, id: $id}) {\n    node {\n      apiKeyId\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e3f9720968087a33878d26eff2956f8";

export default node;
